import { useState, useEffect, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Row } from "react-bootstrap";
import TasksArchives from "../pages/TasksArchives";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import TasksData from "../pages/TasksData";
import TaskAdd from "../pages/TaskAdd";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Tasks() {
  const { userData } = useContext(UserDataContext);
  console.log("UData: ", userData);
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTabTasks", newValue);
  };

  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTabTasks");
    if (savedTab) {
      const parsedTab = parseInt(savedTab, 10);
      if (userData && (userData.permId === "1" || userData.permId === "3")) {
        if (parsedTab >= 0 && parsedTab <= 3) {
          setValue(parsedTab);
        }
      } else {
        if (parsedTab === 0) {
          setValue(parsedTab);
        }
      }
    }
  }, [userData]);

  return (
    <div>
      <VN userData={userData} />
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <ThemeProvider theme={theme}>
          {userData && (userData.permId === "1" || userData.permId === "3") ? (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="underMenu"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
            >
              <Tab label="Rejestracja zlecenia" />
              <Tab label="Lista zleceń" />
              <Tab label="Archiwum" />
            </Tabs>
          ) : (
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="underMenu"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
            >
              <Tab label="Lista zleceń" />
            </Tabs>
          )}
        </ThemeProvider>
      </Box>
      {userData && (userData.permId === "1" || userData.permId === "3") ? (
        <>
          <CustomTabPanel value={value} index={0}>
            <Row>
              <TaskAdd />
            </Row>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Row>
              <TasksData />
            </Row>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Row>
              <TasksArchives />
            </Row>
          </CustomTabPanel>
        </>
      ) : (
        <CustomTabPanel value={value} index={0}>
          <Row>
            <TasksData />
          </Row>
        </CustomTabPanel>
      )}
    </div>
  );
}
